import Vue from 'vue';
import App from './old_purchase_order/app.vue';
// import store from './trades/store';
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const trades = document.getElementById('old-purchase-order-vue');

  if (trades) {
    new Vue({
      el: '#old-purchase-order-vue',
      // store: store,
      render: h => h(App)
    }).$mount();
  }
});